import { useShallow } from "zustand/shallow";
import { useUserStore } from "../../stores";

export const usePermissions = () => {
  return useUserStore(
    useShallow((state) => ({
      permissions: state.permissions,
      hasPermission: state.hasPermission,
      hasAllPermissions: state.hasAllPermissions,
      hasSomePermissions: state.hasSomePermissions,
      setPermissions: state.setPermissions,
    }))
  );
};
